import Icon from 'veui/components/Icon'
import { IconIdCard } from 'dls-icons-vue'

Icon.register('id-card', IconIdCard)
